export default "__VITE_ASSET__dS$th701__"